import { render, staticRenderFns } from "./RoutePaginator.vue?vue&type=template&id=0bcf246f"
import script from "./RoutePaginator.vue?vue&type=script&lang=js"
export * from "./RoutePaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports